import 'whatwg-fetch';
import {params} from './restApi';

const headers = (contentType) => {
  const headers =  new Headers();

  if (contentType) {
    headers.set('Content-Type', contentType);
  }

  const token = localStorage.getItem('x-auth-token');
  if (token) {
    headers.set('x-auth-token', token);
  }

  const locale = localStorage.getItem('locale');
  headers.set('x-i18n-token', (locale ? locale : 'en'));

  return headers;
};

const BASE = '/rest/';

export const fetchGet = (url) => (
  fetch(BASE + url, { headers: headers('application/json') })
    .then(res => handleResult(res))
    .catch(err => handleError(err))
);

export const fetchDelete = (url) => {
  const payload = {
    method: 'DELETE',
    headers: headers('application/json'),
  };

  return fetch(BASE + url, payload)
    .then(res => handleResult(res))
    .catch(err => handleError(err));
};

export const fetchPost = (url, data) => {
  const payload = {
    method: 'POST',
    headers: headers('application/json'),
    body: JSON.stringify(data),
  };

  return fetch(BASE + url, payload)
    .then(res => handleResult(res))
    .catch(err => handleError(err));
};

export const fetchPut = (url, data) => {
  const payload = {
    method: 'PUT',
    headers: headers('application/json'),
    body: JSON.stringify(data),
  };

  return fetch(BASE + url, payload)
    .then(res => handleResult(res))
    .catch(err => handleError(err));
};

export const fetchDisable = (url, data) => {
	  const payload = {
	    method: 'DELETE',
	    headers: headers('application/json'),
	  };

	  return fetch(BASE + url, payload)
	    .then(res => handleResult(res))
	    .catch(err => handleError(err));
};

export const fetchDownload = (url, p) => {
  return fetch(BASE + url + params(p), { headers: headers() })
          .then(res => {
            if( !res.ok ) {
              return res.text().then(text => {
                return Promise.reject({
                  status: res.status,
                  statusText: res.statusText,
                  message: text,
                });
              });
            } else {
              return res.blob()
            }
          })
          .catch(err => handleError(err));
};

export const fetchUpload = (url, file) => {
  const formData = new FormData();
  formData.append('uploadedFile', file);

  const payload = {
    method: 'POST',
    headers: headers(),
    body: formData,
  };

  return fetch(BASE + url, payload)
          .then(res => handleResult(res))
          .catch(err => handleError(err));
};

const handleResult = (res) => {
  if (!res.ok) {
    if (res.status === 500) {
      return res.text().then(text => {
        try {
          const json = JSON.parse(text);
          return Promise.reject({
            status: res.status,
            statusText: res.statusText,
            code: json.code,
            message: json.message,
          });
        } catch (err) {
          return Promise.reject({
            status: 500,
            statusText: 'Internal Server Error',
          });
        }
      });

    } else {
      return Promise.reject({
        status: res.status,
        statusText: res.statusText,
      });

    }
  }

  if (res.status === 204) {
    return {};
  }

  return res.json();
};

const handleError = (err) => {
  if (err.status === 401) {
    localStorage.removeItem('x-auth-token');
    localStorage.removeItem('loggedUser');
    window.location.href = '/';
  }

  if (err.status === 404) {
    window.location.href = '/404.html';
  }

  return Promise.reject(err);
};



// WEBPACK FOOTER //
// ./src/main/cruds/remote.js